import { path, split, gte, pathOr, filter, includes, equals, find, toLower } from 'ramda';
import { ALIMONY, CHILD_SUPPORT, SEPERATE_MAINTENANCE } from 'src/components/MultiFlowInputs/constants';
import { ROLE_COBORROWER, YES } from 'src/constants';
import { MOBILE_HOME } from 'src/features/LoansHome/Products/constants';
import { useSessionHook } from 'src/hooks/useSessionHook';
import { OBJECT_META, LABELS, YES_UPPERCASE_Y } from 'src/services/constants';
import { getLabelValue } from 'src/services/objects/build';
import { getNumberOfYearsAndMonths } from 'src/utilities/formatDate';
import { isEmptyOrNil, isNotEmpty } from 'src/utilities/hasValue';

const isGreaterThan2year = (startDate: string) => gte(pathOr(0, ['years'], getNumberOfYearsAndMonths(startDate)), 2);

const isAlimony = (data: any) => {
  try {
    const filteredResources = filter(
      (otherIncome: any) =>
        includes(
          pathOr('', [OBJECT_META, LABELS, 'source_income'], otherIncome),
          [ALIMONY, CHILD_SUPPORT, SEPERATE_MAINTENANCE]
        ),
      isNotEmpty(data) ? JSON.parse(data) : []
    );
    return isEmptyOrNil(filteredResources);
  } catch (err) {
    return true;
  }
};


const isAdvisorNameEmpty = () => {
  const { advisorUsername } = useSessionHook();
  return isEmptyOrNil(advisorUsername)

};

const isRenewal = () => {
  const { renewal } = useSessionHook();
  if (isEmptyOrNil(renewal)) return false;

  const renewalStr = typeof renewal === 'string'
    ? renewal
    : String(renewal);

  return equals(toLower(renewalStr), YES);
};


const isCoborrower = () => {
  const { loanRole } = useSessionHook();
  return equals(loanRole, ROLE_COBORROWER)

};

const primaryCollateralMobileHome = (loanApp: any) => {
  const collaterals = pathOr([], ['spec', 'collateral'], loanApp);
  return isNotEmpty(
    find((collateral: any) =>
      equals(getLabelValue(collateral, 'is_primary'), YES_UPPERCASE_Y) &&
      equals(pathOr('', ['collateral_information', 'collateral_type'], collateral), MOBILE_HOME),
      collaterals
    )
  )
};

const consent_rules = {
  global: {
    isGreaterThan2year: {
      ruleFlagger: isGreaterThan2year,
    },
    isAlimony: {
      ruleFlagger: isAlimony,
    },
    isAdvisorNameEmpty: {
      ruleFlagger: isAdvisorNameEmpty,
    },
    isCoborrower: {
      ruleFlagger: isCoborrower,
    },
    primaryCollateralMobileHome: {
      ruleFlagger: primaryCollateralMobileHome
    },
    isRenewal: {
      ruleFlagger: isRenewal

    }
  }
};
export const getConsentRule = (rule: any) => {
  const rules = isNotEmpty(rule) ? split('.', rule) : [];
  return path(rules, consent_rules);
};
